import React, { useMemo } from 'react'
import { Box, Grid, Tooltip, Avatar, Typography } from '@mui/material'
import { OrganizationTableItem, Task } from 'types'
import { stringAvatar } from 'components/DataGrid/gridOperators'
const NavigateToOrg = ({
  task,
  organization,
  handleNavigate,
}: {
  task: Task
  organization: OrganizationTableItem
  handleNavigate: (taskRoute: string) => void
}) => {
  const headerUrl = useMemo(() => {
    return task?.isCreative
      ? `/projects/${task?.dealId}/main`
      : task?.isWebsite
      ? `/projects/${task?.dealId}/main`
      : task?.isMarketing
      ? `/nco/${task?.dealId}/tasks`
      : ''
  }, [task])
  return (
    <Grid item xs={12}>
      {organization?.photoUrl ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.8,
            width: '100%',
            justifyContent: 'flex-end',
          }}
        >
          <Typography>{organization?.name}</Typography>
          <Tooltip title={'Navigate to Organization'}>
            <Avatar
              src={organization.photoUrl}
              sx={{
                width: 38,
                height: 38,
                objectFit: 'cover',
                objectPosition: 'center',
                ':hover': { opacity: '0.5', cursor: 'pointer' },
              }}
              alt={organization?.name}
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                // handleNavigate(headerUrl)
                handleNavigate(`/organizations/${organization?.PK}/details`)
              }}
            />
          </Tooltip>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.8,
            width: '100%',
            justifyContent: 'flex-end',
          }}
        >
          <Typography>{organization?.name}</Typography>
          <Tooltip title={'Navigate to Organization'}>
            <Avatar
              {...stringAvatar(organization?.name, { fontSize: 18 })}
              sx={{
                backgroundColor: 'background.defaultdim',
                border: '1px solid rgb(114, 229, 218)',
                width: 38,
                height: 38,
                objectFit: 'cover',
                objectPosition: 'center',
                ':hover': { opacity: '0.5', cursor: 'pointer' },
              }}
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                // handleNavigate(headerUrl)
                handleNavigate(`/organizations/${organization?.PK}/details`)
              }}
            />
          </Tooltip>
        </Box>
      )}
    </Grid>
  )
}

export default NavigateToOrg
